<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header pv-page" [class.pv-page--kanban]="visao === 'kanban'"
    [class.pv-page--expandido]="isCabecalhoRecolhido && visao === 'kanban'">
    <div class="container-header-inner-list">
        <!-- ===== título e ações ===== -->
        @if (!isCabecalhoRecolhido) {
        <div class="row">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Processo de Venda</h1>
                        <p class="welcome-message pv-so-desktop">Fluxo de venda da sua empresa</p>
                    </div>
                </div>
            </div>

            <div class="col-md-6 header-actions pv-so-desktop">
                <!-- "Ações" só existe na visão em Lista, à esquerda dos botões de criação. -->
                @if (visao === 'lista') {
                <!-- Habilitado SEM seleção: imprimir e exportar são da listagem inteira (dos
                     filtros), e só a exclusão é da seleção. -->
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="menuAcoesLote"
                    matTooltip="Ações da listagem">
                    @if (listSelection.hasValue()) {
                    <span>Ações ({{ listSelection.selected.length }})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #menuAcoesLote="matMenu">
                    <!-- Estes dois são da LISTAGEM: respeitam os filtros, não a seleção. -->
                    <button type="button" mat-menu-item (click)="imprimirListagem()">
                        <mat-icon class="material-symbols-outlined">print</mat-icon>
                        <span>Imprimir listagem</span>
                    </button>

                    <button type="button" mat-menu-item [disabled]="!podeExportar" (click)="exportarListagem()">
                        <mat-icon class="material-symbols-outlined">download</mat-icon>
                        <span>Exportar CSV</span>
                    </button>

                    <mat-divider></mat-divider>

                    <!-- Estes são da SELEÇÃO. -->
                    <span class="menu-item-tooltip-wrapper" [matTooltip]="motivoAlterarTagsDesabilitado"
                        [matTooltipDisabled]="!motivoAlterarTagsDesabilitado">
                        <button type="button" mat-menu-item [disabled]="!podeAlterar || !listSelection.hasValue()"
                            (click)="alterarTagsSelecionados()">
                            <mat-icon class="material-symbols-outlined">label</mat-icon>
                            <span>Alterar tags</span>
                        </button>
                    </span>

                    <button type="button" mat-menu-item [disabled]="!podeExcluir || !listSelection.hasValue()"
                        (click)="excluirSelecionados()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionados</span>
                    </button>
                </mat-menu>
                }

                <!-- "+ Novo orçamento" com menu (protótipo): em branco ou a partir de um modelo. -->
                <button mat-stroked-button class="btn-secondary" [disabled]="!podeInserir"
                    [matMenuTriggerFor]="menuNovoOrcamento" (menuOpened)="carregarModelosParaNovo()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Novo orçamento
                    <mat-icon class="material-symbols-outlined pv-novo-seta" iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <button mat-flat-button class="btn-primary" [disabled]="!podeInserir"
                    (click)="novoDocumento(tipoDocumentoEnum.PedidoDeVenda)">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Novo pedido
                </button>
            </div>
        </div>

        <!-- ===== toolbar de filtros ===== -->
        <div class="row search-area" [formGroup]="filterModel">
            <!-- A busca também é filtro: vai na MESMA requisição que vendedor, origem, tags e
                 período. Por isso no mobile ela entra no painel junto com o resto, em vez de
                 gastar uma faixa inteira de altura sozinha. Um template, dois lugares. -->
            <ng-template #campoBusca>
                <mat-form-field appearance="outline" class="filter-pesquisa" subscriptSizing="dynamic">
                    <mat-label>Pesquisar</mat-label>
                    <input matInput placeholder="Pesquise por cliente ou número" formControlName="searchText" />
                    <button mat-icon-button matSuffix type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </ng-template>

            <div class="col-xl-3 col-lg-4 col-12 pv-so-desktop">
                <ng-container [ngTemplateOutlet]="campoBusca"></ng-container>
            </div>

            <div class="col-xl-9 col-lg-8 col-12">
                <div class="filter-actions">
                    <!-- Período. Mesmo menu das listagens do HUB (contas a pagar/receber): as
                         opções fixas aplicam na hora, e "do intervalo" abre os dois campos de data
                         aqui dentro, com Cancelar/Aplicar próprios. As classes periodo-* são
                         globais do styles.css, dark mode incluído. -->
                    <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button"
                        class="btn-filter pv-so-desktop" [class.pv-pill--ativa]="periodo !== 'mes'"
                        [matMenuTriggerFor]="menuPeriodo"
                        (menuOpened)="prepararPeriodoIntervalo()">
                        <mat-icon class="material-symbols-outlined">calendar_month</mat-icon>
                        {{ rotuloPeriodo }}
                    </button>

                    <!-- Opções de período em UM lugar só: o menu da pílula (desktop) e o painel
                         "Filtrar" (mobile) renderizam este mesmo bloco. Duas cópias divergiriam.
                         `aplicaNaHora` distingue os dois: na pílula o clique aplica e fecha; no
                         painel ele só marca o rascunho, e quem aplica é o Aplicar de lá. -->
                    <ng-template #opcoesPeriodo let-aplicaNaHora="aplicaNaHora">

                            <button type="button" class="periodo-menu-item"
                                [class.periodo-item-selecionado]="periodo === 'hoje'"
                                (click)="escolherPeriodo('hoje', aplicaNaHora)">
                                <span>Hoje</span>
                                @if (periodo === 'hoje') {
                                <mat-icon>check</mat-icon>
                                }
                            </button>

                            <button type="button" class="periodo-menu-item"
                                [class.periodo-item-selecionado]="periodo === 'semana'"
                                (click)="escolherPeriodo('semana', aplicaNaHora)">
                                <span>Da semana</span>
                                @if (periodo === 'semana') {
                                <mat-icon>check</mat-icon>
                                }
                            </button>

                            <button type="button" class="periodo-menu-item"
                                [class.periodo-item-selecionado]="periodo === 'mes'"
                                (click)="escolherPeriodo('mes', aplicaNaHora)">
                                <span>Do mês</span>
                                @if (periodo === 'mes') {
                                <mat-icon>check</mat-icon>
                                }
                            </button>

                            <button type="button" class="periodo-menu-item"
                                [class.periodo-item-selecionado]="periodo === 'ultimos30'"
                                (click)="escolherPeriodo('ultimos30', aplicaNaHora)">
                                <span>Últimos 30 dias</span>
                                @if (periodo === 'ultimos30') {
                                <mat-icon>check</mat-icon>
                                }
                            </button>

                            <!-- Este NÃO aplica no clique: só revela os campos abaixo. -->
                            <button type="button" class="periodo-menu-item"
                                [class.periodo-item-selecionado]="periodo === 'personalizado'"
                                (click)="escolherPeriodo('personalizado', false)">
                                <span>Do intervalo</span>
                                @if (periodo === 'personalizado') {
                                <mat-icon>check</mat-icon>
                                }
                            </button>

                            @if (periodo === 'personalizado') {
                            <div class="periodo-intervalo-fields">
                                <mat-form-field appearance="outline">
                                    <mat-label>De</mat-label>
                                    <input matInput [matDatepicker]="pickerPeriodoDe" placeholder="DD/MM/AAAA"
                                        (input)="onDateInput($event, 'dataDe')" formControlName="dataDe" />
                                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerPeriodoDe></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Até</mat-label>
                                    <input matInput [matDatepicker]="pickerPeriodoAte" placeholder="DD/MM/AAAA"
                                        (input)="onDateInput($event, 'dataAte')" formControlName="dataAte" />
                                    <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerPeriodoAte></mat-datepicker>
                                    @if (filterModel.get('dataAte')?.hasError('dataInvalida')) {
                                    <mat-error>Data final menor que inicial</mat-error>
                                    }
                                    @if (filterModel.get('dataAte')?.hasError('intervaloExcedido')) {
                                    <mat-error>Intervalo máx. de {{ limiteMeses }} meses</mat-error>
                                    }
                                </mat-form-field>

                                @if (aplicaNaHora) {
                                <div class="periodo-intervalo-actions">
                                    <button type="button" mat-button class="btn-secondary"
                                        (click)="cancelarPeriodoIntervalo()">
                                        Cancelar
                                    </button>
                                    <button type="button" mat-flat-button class="btn-primary"
                                        (click)="aplicarPeriodo()">
                                        Aplicar
                                    </button>
                                </div>
                                }
                            </div>
                            }
                    </ng-template>

                    <mat-menu #menuPeriodo="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
                        <div class="periodo-menu-content" (click)="$event.stopPropagation()">
                            <ng-container
                                [ngTemplateOutlet]="opcoesPeriodo"
                                [ngTemplateOutletContext]="{ aplicaNaHora: true }"></ng-container>
                        </div>
                    </mat-menu>

                    <!-- Recorte do board: pílula própria, fora do painel Filtrar.
                         No Kanban ela recolhe as raias fora do recorte, sem ir ao servidor. -->
                    <button mat-stroked-button type="button" class="btn-filter pv-so-desktop"
                        [class.pv-pill--ativa]="recorte !== 'todos'" [matMenuTriggerFor]="menuRecorte">
                        <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
                        {{ rotuloRecorte }}
                    </button>

                    <mat-menu #menuRecorte="matMenu">
                        <button mat-menu-item (click)="selecionarRecorte('todos')">Todos os processos</button>
                        <button mat-menu-item (click)="selecionarRecorte('orcamento')">Orçamento</button>
                        <button mat-menu-item (click)="selecionarRecorte('pedido')">Pedido de venda</button>
                        <!-- A faixa e uma raia do board; na Lista nao ha raia para recolher. -->
                        @if (visao === 'kanban') {
                        <button mat-menu-item (click)="selecionarRecorte('envioRetirada')">Envio e retirada</button>
                        }
                    </mat-menu>

                    <!-- Campos e ações do filtro em UM lugar só. No desktop este bloco é o
                         conteúdo do menu "Filtrar"; no mobile é o conteúdo da gaveta. Mesmo
                         rascunho, mesmo Aplicar, mesmo badge — só a moldura muda. -->
                    <ng-template #camposFiltro>
                            <div class="pv-filtros-topo">
                                <h6>Filtros</h6>
                                <button mat-icon-button type="button" class="pv-filtros-fechar"
                                    (click)="fecharPainelFiltros()" aria-label="Fechar filtros">
                                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                                </button>
                            </div>

                            <div class="pv-filtros-busca">
                                <ng-container [ngTemplateOutlet]="campoBusca"></ng-container>
                            </div>

                            <div class="filter-menu__form">
                                @if (exibeFiltroVendedor) {
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Vendedor</mat-label>
                                    <mat-select multiple [(value)]="rascunhoIdsVendedor">
                                        @for (vendedor of vendedoresDisponiveis; track vendedor.id) {
                                        <mat-option [value]="vendedor.id">{{ vendedor.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                }

                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Origem</mat-label>
                                    <mat-select [(value)]="rascunhoIdOrigem">
                                        <mat-option [value]="origemVendaEnum.Todos">Todos</mat-option>
                                        <mat-option [value]="origemVendaEnum.OriginadoDeOrcamento">
                                            Originado de orçamento
                                        </mat-option>
                                        <mat-option [value]="origemVendaEnum.CriadoDiretamente">Criado
                                            diretamente</mat-option>
                                    </mat-select>
                                    <mat-hint>Aplica-se somente aos Pedidos de Venda.</mat-hint>
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>Tags</mat-label>
                                    <mat-select multiple [(value)]="rascunhoIdsTag">
                                        @for (tag of tagsDisponiveis; track tag.idTagVenda) {
                                        <mat-option [value]="tag.idTagVenda">{{ tag.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                <!-- Só na Lista. No board a coluna Modelo está sempre lá e sempre
                                     cheia, então o interruptor não teria o que ligar; na Lista o
                                     modelo é ruído no meio das negociações, e aí ele é filtro
                                     como os de cima. -->
                                @if (visao === 'lista') {
                                <mat-checkbox
                                    class="pv-filtro-modelos"
                                    color="primary"
                                    [checked]="rascunhoIsMostrarModelos"
                                    (change)="rascunhoIsMostrarModelos = $event.checked">
                                    Mostrar modelos
                                </mat-checkbox>
                                }
                            </div>

                            <!-- Mobile: a pílula de Processo também sai da toolbar.
                                 Diferente dos campos acima, este NÃO entra no rascunho: o clique
                                 chama selecionarRecorte() na hora, exatamente como a pílula faz.
                                 É o que preserva a natureza dele — no Kanban ele recolhe raias no
                                 cliente, sem ir ao servidor, e adiar isso para o Aplicar só
                                 tornaria a resposta mais lenta sem ganhar nada.
                                 A consequência assumida: o Cancelar do painel não desfaz o
                                 Processo. Ele é controle de visão, não filtro. -->
                            <div class="pv-filtros-processo periodo-custom-menu">
                                <div class="pv-filtros-secao">Processo</div>
                                <button type="button" class="periodo-menu-item"
                                    [class.periodo-item-selecionado]="recorte === 'todos'"
                                    (click)="selecionarRecorte('todos')">
                                    <span>Todos os processos</span>
                                    @if (recorte === 'todos') {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <button type="button" class="periodo-menu-item"
                                    [class.periodo-item-selecionado]="recorte === 'orcamento'"
                                    (click)="selecionarRecorte('orcamento')">
                                    <span>Orçamento</span>
                                    @if (recorte === 'orcamento') {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <button type="button" class="periodo-menu-item"
                                    [class.periodo-item-selecionado]="recorte === 'pedido'"
                                    (click)="selecionarRecorte('pedido')">
                                    <span>Pedido de venda</span>
                                    @if (recorte === 'pedido') {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <!-- A faixa é uma raia do board; na Lista não há raia para recolher. -->
                                @if (visao === 'kanban') {
                                <button type="button" class="periodo-menu-item"
                                    [class.periodo-item-selecionado]="recorte === 'envioRetirada'"
                                    (click)="selecionarRecorte('envioRetirada')">
                                    <span>Envio e retirada</span>
                                    @if (recorte === 'envioRetirada') {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                }
                            </div>

                            <!-- Mobile: a pílula de Período sai da toolbar e as opções dela vêm
                                 para cá, entrando no mesmo ciclo de rascunho dos filtros acima.
                                 A classe periodo-custom-menu é só para herdar o estilo global dos
                                 itens; a largura fixa de 340px dela é neutralizada no CSS local. -->
                            <div class="pv-filtros-periodo periodo-custom-menu">
                                <div class="pv-filtros-secao">Período</div>
                                <ng-container
                                    [ngTemplateOutlet]="opcoesPeriodo"
                                    [ngTemplateOutletContext]="{ aplicaNaHora: false }"></ng-container>
                            </div>

                            <div class="pv-filtros-acoes">
                                <button mat-stroked-button class="btn-secondary"
                                    (click)="cancelarFiltros()">Cancelar</button>
                                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()">Aplicar</button>
                            </div>
                    </ng-template>

                    <!-- Filtrar: botão neutro, badge vermelho com a quantidade -->
                    <button #filtrosMenuTrigger="matMenuTrigger" mat-stroked-button type="button"
                        class="btn-filter pv-btn-filtrar" [matBadge]="qtdFiltrosAvancados"
                        [matBadgeHidden]="qtdFiltrosAvancados === 0" [matMenuTriggerFor]="menuFiltros"
                        (menuOpened)="prepararRascunhoFiltros()">
                        <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
                        Filtrar
                    </button>

                    <mat-menu #menuFiltros="matMenu" class="filter-custom-menu pv-filtros-menu">
                        <div class="filter-menu-content" (click)="$event.stopPropagation()">
                            <ng-container [ngTemplateOutlet]="camposFiltro"></ng-container>
                        </div>
                    </mat-menu>

                    <button mat-stroked-button type="button" class="btn-filter pv-btn-limpar"
                        (click)="limparFiltros()">
                        <mat-icon class="material-symbols-outlined">cleaning_services</mat-icon>
                        <span class="pv-limpar-rotulo">Limpar Filtros</span>
                    </button>
                </div>
            </div>
        </div>
        }

        <!-- Faixa de escopo: só aparece quando há restrição de verdade. Fica com os filtros,
             acima das abas, porque diz respeito ao que o usuário enxerga nas DUAS visões. -->
        @if (textoEscopo) {
        <div class="pv-escopo">
            <mat-icon class="material-symbols-outlined">visibility</mat-icon>
            {{ textoEscopo }}
        </div>
        }

        <!-- ===== abas e ações da barra ===== -->
        <div class="pv-tabs">
            <button type="button" class="pv-tab" [class.pv-tab--ativa]="visao === 'kanban'"
                (click)="trocarVisao('kanban')">
                <mat-icon class="material-symbols-outlined">view_kanban</mat-icon>
                Kanban
            </button>
            <button type="button" class="pv-tab" [class.pv-tab--ativa]="visao === 'lista'"
                (click)="trocarVisao('lista')">
                <mat-icon class="material-symbols-outlined">list</mat-icon>
                Lista
            </button>

            <span class="pv-tab-spacer"></span>

            <!-- Recarga com o board ja montado: um indicador discreto, nao o esqueleto inteiro,
                 que piscaria a cada tecla da busca. -->
            @if (isCarregando && raias.length > 0) {
            <mat-progress-spinner class="pv-tab-carregando" mode="indeterminate" diameter="16"></mat-progress-spinner>
            }

            <span class="pv-tab-count pv-so-desktop">
                <b>{{ totalRegistrosExibido }}</b> {{ totalRegistrosExibido === 1 ? 'registro' : 'registros' }}
            </span>

            <!-- No modo expandido a linha de titulo some e levaria as acoes junto: elas
                 reaparecem aqui para nao ficarem inacessiveis sem antes recolher o cabecalho. -->
            @if (isCabecalhoRecolhido) {
            <button mat-stroked-button class="btn-secondary pv-tabs-acao pv-so-desktop" [disabled]="!podeInserir"
                [matMenuTriggerFor]="menuNovoOrcamento" (menuOpened)="carregarModelosParaNovo()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                Novo orçamento
                <mat-icon class="material-symbols-outlined pv-novo-seta" iconPositionEnd>arrow_drop_down</mat-icon>
            </button>

            <button mat-flat-button class="btn-primary pv-tabs-acao pv-so-desktop" [disabled]="!podeInserir"
                (click)="novoDocumento(tipoDocumentoEnum.PedidoDeVenda)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                Novo pedido
            </button>
            }

            @if (visao === 'kanban') {
            <button mat-stroked-button type="button" class="btn-secondary pv-expand-btn" (click)="alternarCabecalho()"
                [matTooltip]="isCabecalhoRecolhido ? 'Recolher' : 'Expandir o quadro'">
                <mat-icon class="material-symbols-outlined">
                    {{ isCabecalhoRecolhido ? 'close_fullscreen' : 'open_in_full' }}
                </mat-icon>
                <!-- No mobile sobra só o ícone: o rótulo é o item mais largo desta barra. -->
                <span class="pv-expand-rotulo">{{ isCabecalhoRecolhido ? 'Recolher' : 'Expandir' }}</span>
            </button>
            }
        </div>

        <!-- ===== LISTA =====
             Dentro do container-header-inner-list, como em produto, pessoa e contas a pagar:
             lá o inner-list abre no topo do arquivo e fecha na última linha, envolvendo tabela,
             cards mobile e "Ver Mais". O padding de 24px vem dele, não de regra nossa.
             O board é a exceção e continua irmão, porque precisa sangrar até as bordas. -->
        @if (visao === 'lista') {
        <div class="pv-lista">
            @if (linhasLista.length > 0) {
            <app-pv-lista [linhas]="linhasLista" [listSelection]="listSelection" [isUltimaPagina]="isUltimaPaginaLista"
                [isCarregandoMais]="isCarregandoMaisLista" [podeInserir]="podeInserir"
                [podeExcluir]="podeExcluir" [podeLancarFinanceiro]="podeInserir" [podeExcluirFinanceiro]="podeExcluirFinanceiro"
                [podeLancarEstoque]="podeInserir" [podeExcluirEstoque]="podeExcluirEstoque"
                (alternarTodos)="alternarTodosDaLista()" (abrir)="abrirCard($event)" (criarModelo)="criarModelo($event)" (clonar)="clonar($event)"
                (verHistorico)="verHistorico($event)" (verOportunidadesCliente)="verOportunidadesCliente($event)"
                (excluir)="excluirDocumento($event)"
                [permissoesOportunidade]="permissoesOportunidade"
                (verOportunidade)="verOportunidade($event)" (criarOportunidade)="criarOportunidade($event)"
                (vincularOportunidade)="vincularOportunidade($event)"
                (desvincularOportunidade)="desvincularOportunidade($event)"
                (lancarFinanceiro)="lancarFinanceiro($event)" (excluirFinanceiro)="excluirFinanceiro($event)"
                (lancarEstoque)="lancarEstoque($event)" (excluirEstoque)="excluirEstoque($event)"
                (verFinanceiro)="verFinanceiro($event)"
                (proximaPagina)="proximaPaginaLista()"></app-pv-lista>
            } @else if (isCarregando) {
            <!-- Esqueleto padrao das listagens do HUB, o mesmo de produto, pessoa e categoria. -->
            <div class="table-container">
                <app-loading-box-default-list></app-loading-box-default-list>
            </div>
            } @else {
            <app-empty-list [title]="'Nenhum registro encontrado'"
                [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
            }
        </div>
        }

        <!-- ===== BOARD ===== -->
        @if (visao === 'kanban') {
        <!-- cdkScrollable registra este container no ScrollDispatcher, e é isso que habilita o
         auto-scroll do CDK durante o arraste: chegando na borda com o card na mão, o quadro rola
         sozinho. Sem o registro o CDK não sabe que existe rolagem horizontal aqui, e arrastar
         para uma coluna fora da tela era impossível. -->
    <div class="pv-board-wrapper" cdkScrollable>
            @if (isCarregando && raias.length === 0) {
            <!-- Fantasma com a mesma geometria do board real: raias, colunas e cards.
                     Nada se reposiciona quando os dados chegam. -->
            <div class="pv-board">
                @for (raiaEsqueleto of raiasEsqueleto; track raiaEsqueleto.chave) {
                <app-pv-raia [raia]="raiaEsqueleto" [isSkeleton]="true"></app-pv-raia>
                }
            </div>
            } @else {
            <!-- cdkDropListGroup conecta todas as colunas de todas as raias, inclusive entre
                         processos: a conversão Orçamento → Pedido é um drop cross-raia. O arraste em
                         si só é liberado na fase de mecânicas. -->
            <div class="pv-board" [class.pv-board--recarregando]="isCarregando"
            [class.pv-board--sem-destino]="isPonteiroSobDestinoInvalido" cdkDropListGroup>
                @for (raia of raias; track raia.chave) {
                <app-pv-raia [raia]="raia" [isMostrarSoma]="isMostrarSomaColuna" [aceitaCard]="aceitaCard"
                    [podeArrastar]="podeAlterar" [podeInserir]="podeInserir" [podeExcluir]="podeExcluir"
                    [podeLancarFinanceiro]="podeInserir" [podeExcluirFinanceiro]="podeExcluirFinanceiro"
                    [podeLancarEstoque]="podeInserir" [podeExcluirEstoque]="podeExcluirEstoque"
                    [cardEmArraste]="cardEmArraste"
                    (arrasteIniciou)="iniciarArraste($event)" (arrasteTerminou)="encerrarArraste()"
                    (ponteiroEntrou)="colunaSobPonteiro = $event"
                    (recolherRaia)="alternarRaia($event)"
                    (recolherColuna)="alternarColuna($event)" (verMais)="verMais($event)"
                    (abrirCard)="abrirCard($event)" (moverCard)="moverCard($event)"
                    (criarModelo)="criarModelo($event)"
                    (clonar)="clonar($event)"
                    (verHistorico)="verHistorico($event)"
                    (verOportunidadesCliente)="verOportunidadesCliente($event)"
                    (excluir)="excluirDocumento($event)"
                    [permissoesOportunidade]="permissoesOportunidade"
                    (verOportunidade)="verOportunidade($event)"
                    (criarOportunidade)="criarOportunidade($event)"
                    (vincularOportunidade)="vincularOportunidade($event)"
                    (desvincularOportunidade)="desvincularOportunidade($event)"
                    (lancarFinanceiro)="lancarFinanceiro($event)"
                    (excluirFinanceiro)="excluirFinanceiro($event)"
                    (lancarEstoque)="lancarEstoque($event)"
                    (excluirEstoque)="excluirEstoque($event)"
                    (verFinanceiro)="verFinanceiro($event)"></app-pv-raia>
                } @empty {
                <div class="pv-board-vazio">
                    <mat-icon class="material-symbols-outlined">view_kanban</mat-icon>
                    <div class="pv-board-vazio-titulo">Nenhum processo ativo</div>
                    <div class="pv-board-vazio-apoio">
                        Ative um processo em Configurações &gt;&gt; Vendas &gt;&gt; Kanban para o quadro aparecer.
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
</div>

<!-- FAB de criação, só no mobile.
     Ele substitui a faixa "Novo orçamento"/"Novo pedido" do cabeçalho E as cópias que
     reapareciam na barra de abas quando o quadro é expandido: flutuando sobre o conteúdo, a
     criação fica sempre ao alcance, expandido ou não. Antes eram três lugares para a mesma
     ação; agora é um.
     Geometria copiada do .btn-footer-totals-mobile, o FAB que contas a pagar/receber e o
     extrato já usam. -->
<button
    type="button"
    class="pv-fab"
    [matMenuTriggerFor]="menuNovo"
    (menuOpened)="carregarModelosParaNovo()"
    [disabled]="!podeInserir"
    aria-label="Criar documento">
    <mat-icon class="material-symbols-outlined">add</mat-icon>
</button>

<!-- Mobile: o mesmo padrão do "+ Novo orçamento" do desktop, mais o pedido. Os itens ficam
     escritos DENTRO de cada mat-menu: projetados por template, perderiam o vínculo com o menu
     (o clique não o fecharia). -->
<mat-menu #menuNovo="matMenu" class="pv-menu-novo">
    <button mat-menu-item type="button" (click)="novoDocumento(tipoDocumentoEnum.PedidoDeVenda)">
        <mat-icon class="material-symbols-outlined">add_shopping_cart</mat-icon>
        <span>Novo pedido</span>
    </button>

    <mat-divider></mat-divider>

    <div class="pv-menu-novo-subtitulo">Novo orçamento</div>

        <button mat-menu-item type="button" (click)="novoDocumento(tipoDocumentoEnum.Orcamento)">
            <mat-icon class="material-symbols-outlined">note_add</mat-icon>
            <span>orçamento em branco</span>
        </button>

        <div class="pv-menu-novo-subtitulo">a partir do modelo</div>

        @if (isCarregandoModelos) {
        <button mat-menu-item type="button" disabled>
            <mat-icon class="material-symbols-outlined">hourglass_empty</mat-icon>
            <span>Carregando modelos…</span>
        </button>
        } @else {
        <!-- T15: muitos modelos rolam dentro do menu, sem empurrar a tela. -->
        <div class="pv-menu-novo-modelos">
            @for (modelo of modelosParaNovo; track modelo.idVenda) {
            <button mat-menu-item type="button" [matTooltip]="tooltipModelo(modelo)" matTooltipPosition="left"
                (click)="novoAPartirDoModelo(modelo)">
                <mat-icon class="material-symbols-outlined">description</mat-icon>
                <span>{{ rotuloModelo(modelo) }}</span>
            </button>
            } @empty {
            <p class="pv-menu-novo-vazio">Nenhum modelo cadastrado. Use “criar modelo” em um orçamento para gerar um.</p>
            }
        </div>
        }
</mat-menu>

<mat-menu #menuNovoOrcamento="matMenu" class="pv-menu-novo">
        <button mat-menu-item type="button" (click)="novoDocumento(tipoDocumentoEnum.Orcamento)">
            <mat-icon class="material-symbols-outlined">note_add</mat-icon>
            <span>orçamento em branco</span>
        </button>

        <div class="pv-menu-novo-subtitulo">a partir do modelo</div>

        @if (isCarregandoModelos) {
        <button mat-menu-item type="button" disabled>
            <mat-icon class="material-symbols-outlined">hourglass_empty</mat-icon>
            <span>Carregando modelos…</span>
        </button>
        } @else {
        <!-- T15: muitos modelos rolam dentro do menu, sem empurrar a tela. -->
        <div class="pv-menu-novo-modelos">
            @for (modelo of modelosParaNovo; track modelo.idVenda) {
            <button mat-menu-item type="button" [matTooltip]="tooltipModelo(modelo)" matTooltipPosition="left"
                (click)="novoAPartirDoModelo(modelo)">
                <mat-icon class="material-symbols-outlined">description</mat-icon>
                <span>{{ rotuloModelo(modelo) }}</span>
            </button>
            } @empty {
            <p class="pv-menu-novo-vazio">Nenhum modelo cadastrado. Use “criar modelo” em um orçamento para gerar um.</p>
            }
        </div>
        }
</mat-menu>
